export default {
  agency_key: '',
  mode: '',
  beian: '',
  beian_gn: '',


  chat_url: '',
  address: '上海市徐汇区宜山路700号A7楼709',
  uc_host: 'http://i.howkeduo.com',
  site_host: 'http://www.howkeduo.com',
  special_url: '/',
  site_title: '号客多-400电话云呼叫中心',
  welcome_title: '号客多 — 400电话云呼叫中心！',
  site_short_title: '号客多',
  site_subtitle: '400电话云呼叫中心',
  company_name: '上海亿哲网络科技有限公司',
  copyright: '© 2020 上海亿哲网络科技有限公司',
  logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/assets/image/400logo.jpg',
  favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/assets/image/suggest-sprite_meitu_1.png',
  payment: '',
  qq: '609143760',
  tel: '4008822155',
  recharge_tel: '4008822155',
  company_account_id: '3105 0184 4200 0000 0042',
  company_bank: '中国建设银行上海邯郸路支行',
  company_bank_name: '上海亿哲网络科技有限公司',
  alipay_account_id: '',
  alipay_name: '',
  alipay_pic: '',
  section_id: 0,
  belonger_id: 0,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 